import { useEffect } from 'react'

const BASE_TITLE = 'Bil+ Admin'

// Sets the browser tab title to "Bil+ Admin - <suffix>" while mounted, restoring
// the base title on unmount. A falsy suffix (e.g. while data is loading) just
// shows the base title.
export function useDocumentTitle(suffix?: string | null) {
  useEffect(() => {
    document.title = suffix ? `${BASE_TITLE} - ${suffix}` : BASE_TITLE
    return () => {
      document.title = BASE_TITLE
    }
  }, [suffix])
}
